import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';
import { UrlBuilder } from './urlBuilder.service';
import { HMC_PAGE_PATH, HMC_VISIBILITY_PATH } from '../constants/replatform/hmc-endpoint-url';
import { HmcBannerRequestParams } from '../types/api-params/hmcBanner';
import { HmcVisibilityResponse } from '../types/api/hmc-visibility-api';

export class HmcSubcategoriesHandler extends RequestHandler {
  api = {
    target: 'hmc-subcategories',
    default: 'hmc-default',
  };

  fetchSingleSubcategoryWithHMC(
    parameters: HmcBannerRequestParams,
  ): NetworkResponse<HmcVisibilityResponse> {
    return this.get<HmcVisibilityResponse>(
      UrlBuilder.buildHmcURL({
        ...parameters,
        endPointName: HMC_VISIBILITY_PATH,
        resources: HMC_PAGE_PATH.SUBCATEGORY_PAGE,
      }),
    );
  }
}

export const HmcSubcategories = new HmcSubcategoriesHandler();
